import { Image, Text } from '@change/ds-core-ui';

import { TranslateHtml } from '@change-corgi/core/react/i18n';

import { useHomepagePageData } from 'src/app/pages/homepage/pageContext';

import { SapIssueForm } from './components/SapIssueForm';
import { Tagline } from './components/Tagline';
import { TopImpactStoriesDesktop } from './components/TopImpactStoriesDesktop';
import { TopImpactStoriesMobile } from './components/TopImpactStoriesMobile';
import { TopImpactStoriesMobileProvider } from './components/TopImpactStoriesMobile/hooks/TopImpactStoriesMobileContext';

function BgImagePreload({ fetchPriority: fetchpriority }: { fetchPriority: string }) {
	return (
		<Image
			src="https://static.change.org/homepageV3/background-globe-sunrise.svg"
			alt="Globe"
			{...(fetchpriority ? { fetchpriority } : {})}
			className="absolute -translate-y-[20%] translate-x-0 overflow-visible bg-transparent object-cover max-md:h-full md:left-1/2 md:top-[15%] md:-translate-x-1/2 md:-translate-y-[30%]"
		/>
	);
}

export const HeroSection: React.FC = () => {
	const {
		data: { topImpactStories },
	} = useHomepagePageData();

	return (
		<section
			data-testid="homepage-sunrise-hero-section"
			className="relative overflow-hidden bg-gradient-to-b from-blue-50/0 via-blue-50/80 to-blue-50/0 text-typography-strong"
		>
			<BgImagePreload fetchPriority="high" />
			<div className="container relative z-10 pt-6 md:pt-11 lg:pt-[60px]">
				<div className="">
					<Text data-testid="homepage-hero-heading" variant="display" as="h1" className="m-0 mb-7 text-center lg:mb-10">
						<TranslateHtml value="corgi.homepage.hero_sunrise.title" />
						<span className="text-typography-brand">.</span>
					</Text>
					<SapIssueForm />
					<Tagline />
				</div>

				{topImpactStories.length > 0 && <TopImpactStoriesDesktop />}
			</div>
			{topImpactStories.length > 0 && (
				<TopImpactStoriesMobileProvider>
					<TopImpactStoriesMobile />
				</TopImpactStoriesMobileProvider>
			)}
		</section>
	);
};
